import styled from "styled-components";

const ModalPin = styled.div`
  @media screen and (max-width: 660px) {
    div[class*="ContentWrapper"] {
      background-color: white;
      right: 0;
    }
  }
`;

ModalPin.displayName = "ModalPin";

export { ModalPin };
